import { useEffect } from "react";
import { X } from "lucide-react";
import { legalDocs } from "../legalContent";

const LegalModal = ({ docKey, onClose }) => {
  const doc = docKey ? legalDocs[docKey] : null;

  useEffect(() => {
    if (doc) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [doc]);

  if (!doc) return null;

  return (
    <div
      className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center p-0 sm:p-6"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" />
      <div
        className="relative bg-white w-full sm:max-w-2xl max-h-[90vh] sm:max-h-[85vh] rounded-t-3xl sm:rounded-3xl shadow-2xl flex flex-col animate-fade-up"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-start justify-between gap-4 px-7 pt-7 pb-5 border-b border-slate-100">
          <div>
            <h3 className="font-display text-[24px] text-slate-900" style={{ fontWeight: 800 }}>
              {doc.title}
            </h3>
            {doc.subtitle && (
              <p className="mt-1 text-[14px] text-slate-500">{doc.subtitle}</p>
            )}
          </div>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-9 h-9 rounded-full bg-slate-100 text-slate-700 hover:bg-slate-200 transition-colors shrink-0"
            aria-label="Schließen"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Scrollable content */}
        <div className="overflow-y-auto px-7 py-6 space-y-7">
          {doc.sections.map((sec, i) => (
            <section key={i}>
              {sec.heading && (
                <h4 className="font-display text-[17px] text-slate-900 mb-2" style={{ fontWeight: 700 }}>
                  {sec.heading}
                </h4>
              )}
              <div className="space-y-1.5 text-[14px] leading-relaxed text-slate-600">
                {sec.lines?.map((l, j) => (
                  <p key={j} className={l.strong ? "font-semibold text-slate-900" : ""}>
                    {l.text}
                  </p>
                ))}
                {sec.list && (
                  <ul className="list-disc pl-5 space-y-1 pt-1">
                    {sec.list.map((item, k) => (
                      <li key={k}>{item}</li>
                    ))}
                  </ul>
                )}
                {sec.after?.map((l, m) => (
                  <p key={m} className="pt-1">
                    {l.text}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        {/* Footer */}
        <div className="px-7 py-4 border-t border-slate-100">
          <button
            onClick={onClose}
            className="w-full inline-flex items-center justify-center px-5 py-3 rounded-lg bg-slate-900 text-white font-semibold hover:bg-slate-800 transition-colors"
          >
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
